export default class Shippingtracker {
    constructor(r) {
        this.item = {};
        if(r != false) {
            this.item = r;
        }

        this.defaults();
    }

    isset(key) {
        if(typeof this.item[key] === 'undefined') {
            return false;
        }

        return true;
    }

    output() {
        return this.item;
    }

    defaults() {

        if(!this.isset('primary_color')) {
            this.item.primary_color = '#cd7eae';
        }

        if(!this.isset('text_package_tracking')) {
            this.item.text_package_tracking = 'Shipment tracking';
        }

        if(!this.isset('text_package_tracking_button')) {
            this.item.text_package_tracking_button = 'Open tracking page';
        }

        if(!this.isset('id')) {
            this.item.id = false;
        }


    }
}


// WEBPACK FOOTER //
// ./helpers/shippingtracker.js